import { isArray, isHttpURL } from "../../object";

export class HttpServerException {

    constructor() {
        this.whiteUrls = [];
    }

    init(option) {
        // console.log("HttpServerException-option:", option);

        if (option.whiteUrls && isArray(option.whiteUrls)) {
            this.whiteUrls = option.whiteUrls;
            // console.log("this.whiteUrls:", this.whiteUrls);
        }

        var that = this;
        const _XMLHttpRequest = window.XMLHttpRequest;
        window.XMLHttpRequest = function XMLHttpRequest() {
            const _xhr = new _XMLHttpRequest();
            _xhr.addEventListener("readystatechange", () => {
                if (that.whiteUrls.indexOf(_xhr.responseURL.split("?")[0]) > -1) {
                    // console.log("包含");
                } else {//不包含
                    if (_xhr.readyState === 4) {
                        if (_xhr.status >= 200 && _xhr.status < 300) {
                            // console.log(_xhr.status, "请求成功了");
                        } else {
                            // console.log(_xhr.status, "请求失败了");
                            that.sendHttpServerError('HttpRequestError:' + _xhr.status, _xhr.responseURL, _xhr.statusText, '');
                        }
                    }

                }
            })

            return _xhr;
        }

        const _fetch = window.fetch;

        window.fetch = function (url, options) {//options 请求参数配置帮助业务进一步确认问题

            const _fecPromise = _fetch(url, options);
            return _fecPromise.then((res) => {
                // ignore
                // 有业务方通过 fetch 来将 base64 转化成 blob
                if (!isHttpURL) {
                    return res;
                }
                // console.log(res.url, "成功了");
                // console.log(res.status);
                // console.log(res.ok);
                if (that.whiteUrls.indexOf(url.split("?")[0]) > -1) {
                    // console.log("包含");
                } else {//不包含
                    if (!res.ok) {//HTTP 404 状态并不被认为是网络错误。
                        that.sendHttpServerError('HttpRequestError:' + res.status, res.url, options, '');
                    }
                }
                return res;
            }).catch((err) => {//当遇到网络错误时，fetch() 返回的 promise 会被 reject，并传回 TypeError，虽然这也可能因为权限或其它问题导致。
                // console.log(url, err, "出错了");
                // that.sendError(err);
            });
        }
        // console.log("window.fetch:", window.fetch);
    }



    sendError(err) { }

    sendHttpServerError(type, stacktrace, message, name) { }

}